import { useSelector } from "react-redux";

import { useThunkDispatch } from "@redux/dispatcher";
import {
    addDiscriminator,
    removeDiscriminator,
} from "@redux/modules/value/scrollLock/scrollLock.actions";
import { isLockedFor } from "@redux/modules/value/scrollLock/scrollLock.selectors";

const SCROLL_LOCK_CLASS = "scroll-lock";

const useScrollLock = (discriminator: string) => {
    const dispatch = useThunkDispatch();

    const lockedForDiscriminator = useSelector(isLockedFor(discriminator));

    const isLocked = () => document.body.classList.contains(SCROLL_LOCK_CLASS);

    const isLockedForDiscriminator = () => lockedForDiscriminator;

    const lock = () => {
        dispatch(addDiscriminator(discriminator)).then(() => {
            const offsetY = window.scrollY;
            document.body.style.top = `${-offsetY}px`;
            document.body.classList.add(SCROLL_LOCK_CLASS);
        })
    };

    const unlock = () => {
        dispatch(removeDiscriminator(discriminator)).then(discriminators => {
            if (!discriminators?.length && isLocked()) {
                const offsetY = Math.abs(parseInt(document.body.style.top || "0"));
                document.body.classList.remove(SCROLL_LOCK_CLASS);
                document.body.style.removeProperty('top');
                window.scrollTo(0, offsetY);
            }
        });
    };

    const toggle = () => {
        (isLockedForDiscriminator() ? unlock : lock)();
    };

    return { lock, unlock, toggle, isLocked, isLockedForDiscriminator };
};

export { useScrollLock };
